import { styled } from '@mui/material/styles'

export const PointerWrapper = styled('div')`
  cursor: pointer;
`
